export const TESTIMONIALS_TITLE = 'Happy Clients';

export interface Testimonial {
  quote: string;
  author: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'We had a great experience with the Cornerstone team during our home addition. I would consider this a large project spanning many months and complex modifications to our home. The team was great at keeping us informed, educating us on the hard decisions to be made, and delivering high quality results. I would recommend this team to anyone considering home modifications.',
    author: 'Charles Eberhardt',
  },
  {
    quote:
      "All of the crew were wonderful to work with. We were working with Craig and Julie long distance. I'm pretty sure they had us on speed dial. Everyone that sees our house now says it doesn't even look like the same house and it feels brand new. We absolutely love it!",
    author: 'Debi Smith',
  },
  {
    quote:
      'Totally and completely in love with my new kitchen and sunroof. The entire Cornerstone were amazing to work with. Workmanship is outstanding as well as customer service. Guided me through every step and made me feel comfortable about the whole process. Can\'t recommend them enough! Job well done guys!',
    author: 'Lousie Capps',
  },
];
